// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ReportsView_Wrapper__2qbqY","Image":"ReportsView_Image__34eMx","Text":"ReportsView_Text__6CDZI"};